import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBodyHeart = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16.1941 15.8192L12.4508 19.7242C12.3925 19.785 12.3225 19.8334 12.245 19.8665C12.1676 19.8996 12.0842 19.9167 11.9999 19.9167C11.9157 19.9167 11.8323 19.8996 11.7548 19.8665C11.6773 19.8334 11.6074 19.785 11.5491 19.7242L7.80493 15.8183"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.22574 10.8225C2.85056 10.1502 2.64519 9.39646 2.62747 8.62676C2.60976 7.85706 2.78022 7.09468 3.12407 6.40583V6.40583C3.45912 5.73593 3.94854 5.15522 4.55203 4.71157C5.15551 4.26791 5.85577 3.97399 6.59512 3.85404C7.33446 3.73408 8.09173 3.79152 8.80453 4.02162C9.51732 4.25172 10.1652 4.64789 10.6949 5.17749L11.9999 6.47833L13.3049 5.17333C13.8346 4.64372 14.4825 4.24755 15.1953 4.01745C15.9081 3.78735 16.6653 3.72991 17.4047 3.84987C18.144 3.96983 18.8443 4.26374 19.4478 4.7074C20.0513 5.15106 20.5407 5.73176 20.8757 6.40166V6.40166C21.2196 7.09041 21.3903 7.85264 21.373 8.62227C21.3558 9.3919 21.151 10.1457 20.7766 10.8183"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 13.3192H8.05667C8.11474 13.3192 8.17167 13.3031 8.22112 13.2726C8.27056 13.2421 8.31057 13.1985 8.33667 13.1467L9.7725 10.2742C9.80011 10.217 9.84443 10.1696 9.89959 10.1382C9.95475 10.1068 10.0181 10.0929 10.0814 10.0983C10.1446 10.1037 10.2047 10.1282 10.2537 10.1686C10.3027 10.2089 10.3383 10.2632 10.3558 10.3242L11.7567 14.9908C11.7761 15.051 11.8133 15.1038 11.8633 15.1424C11.9133 15.181 11.9738 15.2036 12.0369 15.2072C12.1 15.2108 12.1627 15.1953 12.2168 15.1626C12.2709 15.1299 12.3138 15.0817 12.34 15.0242L13.6483 11.9708C13.6706 11.9192 13.7064 11.8745 13.7519 11.8415C13.7974 11.8085 13.851 11.7883 13.907 11.7831C13.963 11.7779 14.0194 11.7879 14.0702 11.8119C14.121 11.836 14.1644 11.8734 14.1958 11.92L15.1258 13.315H21.3758"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBodyHeart.displayName = 'SvgBodyHeart';
export default SvgBodyHeart;
